import { render, staticRenderFns } from "./Table-Page.vue?vue&type=template&id=63e667f0&"
import script from "./Table-Page.vue?vue&type=script&lang=ts&"
export * from "./Table-Page.vue?vue&type=script&lang=ts&"
import style0 from "./Table-Page.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports